// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34R6Z","largestCol":"styles_largestCol__11wrI","smallestCol":"styles_smallestCol__1ZX9I"};